export const normalizedSlotData = (data: any) => ({
  ...data,
  setRef: data.setRef ?? (() => {}),
})

export const getClickName = (target: HTMLElement) =>
  target?.getAttribute('data-click-name') ?? undefined

export const getClickNameOfTarget = (event: PointerEvent | UIEvent) => {
  const target = event.target
  if (!(target instanceof HTMLElement)) return

  return getClickName(target)
}

export const getSlot = <T extends LooseObject>(slots: T, name: keyof T) =>
  (slots?.[name]?.() as VNode[])?.[0]

export const removeTrackingProps = <T extends LooseObject>(props: T) => R_omit(props, ['tracking'])

const SANITIZE_PARAMS = ['token']

export const sanitizeParams = (url: string) => {
  const urlString = url.startsWith('http') ? url : `http://localhost${url}`
  const fullUrl = new URL(urlString)
  const params = new URLSearchParams(fullUrl.search)

  SANITIZE_PARAMS.forEach((key) => {
    if (params.has(key)) params.set(key, '***')
  })

  return params.size > 0 ? `${fullUrl.pathname}?${params.toString()}` : fullUrl.pathname
}
